import { useState } from "react";
import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import {
  PrimaryButton,
  PrimaryButtonText,
  SecondaryButtonText,
} from "../../components/ui/Button";
import { InputField } from "../../components/ui/Inputs";
import { ArrowBack, ArrowForward, Business } from "@mui/icons-material";
import { ReactComponent as EyeOffIcon } from "../../assets/icons/auth/eye-off.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/auth/eye.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SubmitHandler, useForm } from "react-hook-form";
import postsServices from "../../services/api/service/postsService";
import Toast from "../../components/ui/Toast";
import LoaderBackdrop from "../../components/ui/LoaderBackdrop";
import { ROUTES } from "../../routes/routerConfig";
import {
  clearOtpUserData,
  setUserAuth,
  authSelector,
  clearPasswordType,
  setUserPermission,
  setUserBusinessType,
  setUserLoanCategory,
} from "../../services/redux/slices/authSlice";
import service from "../../services/api/service";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import regex from "../../data/regex";
import InputLabelComp from "../../components/ui/InputLabelComp";
import ButtonLoader from "../../components/ui/ButtonLoader";
import { encrypt, decrypt } from "../../utils/crypto";
import { trackEvent } from "../../utils/ga";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import { setSelectedIndex, setTabType } from '../../services/redux/slices/tabsSlice';
import { setIsShowReferralBanner } from "../../services/redux/slices/dashboardDataSlice";

interface FormInputs {
  enterPassword: string;
}

type props = {
  setNextStep: (step: string) => void;
  // Carries the password to LoginType for a multi-business-type login,
  // outside Redux — see Router.tsx's pendingLoginPassword.
  setPendingLoginPassword: (password: string) => void;
};

const EnterPassword = ({ setNextStep, setPendingLoginPassword }: props) => {
  const { userProfile } = useSelector(authSelector);
  const [showPassword, setShowPassword] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [toastSeverity, setToastSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm<FormInputs>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleBack = () => {
    setNextStep("");
  };

  const handleToastClose = () => setToastOpen(false);

  const handleToastOpen = (
    message: string,
    severity: "error" | "warning" | "info" | "success"
  ) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const userLoginSingleLoanType = (businessType: any, password: string) => {
    let checkBusinessId =process.env.REACT_APP_PAYLOAD_ENCRYPTION != "true" && process.env.REACT_APP_LOAD_TESTING=="true";
    const payload = {
      businessId:checkBusinessId ? "1" : encrypt(businessType?.id?.toString()),
      id: userProfile?.id?.toString(),
      password: encrypt(password?.toString()),
    };
    service?.auth
      ?.setLogin(payload)
      .then((response) => {
        const token = response?.data?.data?.token;
        const permissionObj = response?.data?.data?.permission;
        const loanCategoryObj = response?.data?.data?.result;
        if(loanCategoryObj?.Flexi?.length > 0 || loanCategoryObj?.TermLoan?.length > 0) {
          dispatch(setIsShowReferralBanner(true))
        }

        navigate("/application/existing-application")


        // if (loanCategoryObj?.Flexi?.length == 0 && loanCategoryObj?.TermLoan?.length == 0) {
        //   navigate("/application")
        // } else if (loanCategoryObj?.Flexi?.length > 0 || loanCategoryObj?.TermLoan?.length > 0) {
        //   navigate("/dashboard")
        // }

        dispatch(setUserAuth(token));
        dispatch(setUserPermission(permissionObj));
        dispatch(setUserBusinessType(businessType));
        dispatch(setUserLoanCategory(loanCategoryObj));
        dispatch(setSelectedIndex(0));
        if(loanCategoryObj?.Flexi?.length > 0 && loanCategoryObj?.TermLoan?.length > 0){
          dispatch(setTabType("Term Loan"));
        }else{
          if(businessType?.name === "entity" && loanCategoryObj?.Flexi?.length <= 0 ){
            dispatch(setTabType("Term Loan"));
          }else if(businessType?.name==="entity"){
            dispatch(setTabType("Flexi Term Loan"));
          }else{
            dispatch(setTabType("Term Loan"));
          }
        }
        setPendingLoginPassword("");

      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(
          setStatusPopup({
            status: "error",
            message: errorMessage,
          })
        );
      });
  };

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    trackEvent('Enter_Password_Continue', decrypt(userProfile?.id), {
      label: 'Enter_Password_Continue',
      category: 'Enter_Password_Continue',
      action: "Enter_Password_Continue",
    });

    let cifNumberValue = "";
    if (userProfile?.cifNumber) {
      cifNumberValue = decrypt(userProfile?.cifNumber);
    } else if (userProfile?.email && userProfile?.phoneNumber) {
      cifNumberValue = decrypt(userProfile?.phoneNumber);
    }

    const password = data.enterPassword;
    setIsLoading(true);
    const payload = {
      cifNumber:encrypt(cifNumberValue),
      password: encrypt(password),
    };
    service?.auth
      ?.userLogin(payload)
      .then((response) => {
        // const token = response?.data?.data?.token;
        // const permissionObj = response?.data?.data?.permission;
        const businessObj = response?.data?.data?.business_type;
        dispatch(clearOtpUserData());
        // dispatch(setUserAuth(token));
        // dispatch(setUserPermission(permissionObj));
        dispatch(clearPasswordType());
        sessionStorage.setItem("deviceType", "web");
        // handleToastOpen("Login successful", "success");
        if (businessObj.length > 1) {
          dispatch(setUserBusinessType(businessObj));
          setPendingLoginPassword(password);
          // navigate(ROUTES.Login.loginType.locationPath, { replace: true });
          setNextStep(ROUTES?.Login?.loginType?.path);
        } else {
          userLoginSingleLoanType(businessObj[0], password);
        }
        setIsLoading(false);
        // navigate(ROUTES.Dashboard.index, { replace: true });
      })
      .catch((error) => {
        setValue("enterPassword", "", { shouldValidate: true });
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        setIsLoading(false);
        dispatch(
          setStatusPopup({
            status: "error",
            message: errorMessage,
          })
        );
      });
  };

  const onKeyDownHandler = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      // Prefer 'e.key' over 'e.keyCode'
      e.preventDefault(); // Prevent default form submission behavior
      handleSubmit(onSubmit)(); // Properly invoke handleSubmit with the onSubmit handler
    }
  };

  return (
    <Box>
      <Toast
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleToastClose}
      />

      <PrimaryButtonText
        startIcon={<ArrowBack color="inherit" fontSize="small" />}
        onClick={handleBack}
      >
        Back
      </PrimaryButtonText>

      <Box className="main-wrapper">
        <Box className="head-section">
          <Box className="heading">Enter your password</Box>
          <Box className="sub-heading">
            Enter your password to access your account
          </Box>
        </Box>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        <InputLabelComp title="Enter Password" css={true} />
        <InputField
          type={showPassword ? "text" : "password"}
          required
          fullWidth
          autoFocus
          borderRadius="6px"
          autoComplete="off"
          //label="Enter Password"
          placeholder="Enter Password"
          {...register("enterPassword", {
            required: "Password is required",
            validate: (value) =>
              value.trim().length > 0 || "Password is required",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long",
            },
            maxLength: {
              value: 15,
              message: "Password cannot exceed 15 characters",
            },
            pattern: {
              value: regex?.password,
              message:
                "Password must contain one capital letter and symbol @$!%*?& or numbers",
            },
          })}
          onKeyDown={(e: any) => onKeyDownHandler(e)}
          error={!!errors.enterPassword}
          helperText={errors.enterPassword && errors.enterPassword.message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                >
                  {showPassword ? <EyeIcon /> : <EyeOffIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <PrimaryButton
            type="button"
            onClick={handleSubmit(onSubmit)}
            fullWidth
            disabled={isLoading}
          >
            <ButtonLoader title="Continue" isLoading={isLoading} />
          </PrimaryButton>
          <SecondaryButtonText
            onClick={() => setNextStep(ROUTES?.Login?.forgotPassword?.path)}
          >
            Forgot Password
          </SecondaryButtonText>
        </Box>
        {/* </form> */}
      </Box>
      {/* <LoaderBackdrop open={isLoading} /> */}
    </Box>
  );
};

export default EnterPassword;
